import { Component, computed, inject } from '@angular/core';
import { Divider } from '@openng/optimus-ui/divider';
import {
    ServiceCertificatesSettingsComponent,
} from '../../../../../../components/medical-service/service/settings/service-certificates-settings/service-certificates-settings.component';
import {
    ServiceDoctorsSecretsComponent,
} from '../../../../../../components/medical-service/service/settings/service-doctors-secrets/service-doctors-secrets.component';
import {
    ServiceSettingsCommonComponent,
} from '../../../../components/services/settings/service-settings-common/service-settings-common.component';
import { WarnFloatMessageComponent } from '../../../../../../components/kit/float-message/warn-float-message.component';
import { routeParams } from '../../../../../shared/shared.global-service';
import { UserSecretTypeEnum } from '@libs/types/src/user/enum/user-secret-type.enum';
import { SERVICE_SETTINGS_EPOUKAZ_TYPE_KEY } from '@libs/types/src/services/types/common-service-settings.type';
import { ServiceSettingsEpoukazStore } from './service-settings-epoukaz.store';

@Component({
    selector: 'app-service-settings-epoukaz',
    templateUrl: './service-settings-epoukaz.component.html',
    styleUrl: './service-settings-epoukaz.component.scss',
    providers: [ServiceSettingsEpoukazStore],
    imports: [
        ServiceSettingsCommonComponent,
        Divider,
        ServiceDoctorsSecretsComponent,
        ServiceCertificatesSettingsComponent,
        WarnFloatMessageComponent,
    ],
})
export class ServiceSettingsEpoukazComponent {
    protected readonly store = inject(ServiceSettingsEpoukazStore);

    protected readonly isPzsMissing = computed(() => (
        !this.store.eprescriptionSettings()?.pzs?.trim()
    ));

    protected readonly SERVICE_SETTINGS_EPOUKAZ_TYPE_KEY = SERVICE_SETTINGS_EPOUKAZ_TYPE_KEY;
    protected readonly routeParams = routeParams;
    protected readonly Number = Number;
    protected readonly UserSecretTypeEnum = UserSecretTypeEnum;
}
